export default {
  props: {
    title: {
      type: String,
      required: false,
      default: function() {
        return this.$t('shared.how_they_talk');
      },
    },
    brands: {
      type: Array,
      required: false,
      default: () => [
        {
          class: 'vanguardia',
          src: "/img/brands/lavanguardia.png",
          article: null

        },
        {
          class: 'elmundo',
          src:  "/img/brands/elmundo.png",
          article: 'https://www.elmundo.es/viajes/el-baul/2017/11/07/5a0054f4268e3e7c1d8b46d6.html'
        },
        {
          class: 'traveler',
          src: "/img/brands/traveler.png",
          article: 'https://www.traveler.es/viajes-urbanos/articulos/ahora-vuelvo-mama-vuelos-europa-madrid-barcelona/11703'
        },
        {
          class: 'larazon',
          src: "/img/brands/larazon.png",
          article: null

        },
        {
          class: 'radio-flaixbac',
          src: "/img/brands/radio-flaixbac.png",
          article: null
        },
        {
          class: 'elplural',
          src: "/img/brands/elplural.png",
          article: 'https://www.elplural.com/pimienta/la-start-up-ahora-vuelvo-mama-aterriza-en-madrid-despues-del-exito-cosechado-en-barcelona_100055102'
        },
        {
          class: 'cadena-ser',
          src: "/img/brands/cadena-ser.png",
          article: null

        },
        {
          class: 'ondacero',
          src: "/img/brands/ondacero.png",
          article: 'https://www.ondacero.es/programas/mas-de-uno/programas-completos/mas-de-uno-24112017_201711245a180b1e0cf232e79ce837f9.html'
        }
      ]
    }
  },
  created() {},
  computed: {
    getBrandsToShowDesktop() {
      if (window.innerWidth > 768) {
        return this.brands.slice(0, 4);
      } else {
        return this.brands.slice(0, 2);
      }
    },
    getBrandsToShowMobile() {
      if (window.innerWidth > 768) {
        return this.brands.slice(4, 8); 
      } else {
        return this.brands.slice(2, 8); 
      }
    }
  },
};
